export const listenToMessagesFromOrigin: ListenToMessagesFromOrigin = (
  listener: (data: any) => void,
  origin?: string
): void => {
  window.onmessage = event => {
    if (event.origin === origin) {
      listener(event.data);
    }
  };
};

export const postMessageToIframe: PostMessageFunction = (
  iframeRef,
  message,
  targetOrigin
): void => {
  (iframeRef as React.RefObject<HTMLIFrameElement>).current?.contentWindow?.postMessage(
    message,
    targetOrigin
  );
};
